<template>
  <div 
    class="fts-automation-contenteditable"
    @mouseover="onMouseover"
    @mouseleave="onMouseleave"
  >
    <div class="automation-contenteditable">
      <fts-contenteditable
        v-model="content"
        :placeholder="placeholder"
        :contenteditable="editMode"
        :key="editMode"
        class="automation-contenteditable-control"
        @input="onInput"
        @input:blur="onBlur"
        @input:focus="onFocus"
        ref="ftsContenteditable"
      />
      <i
        class="fts-icon-edit automation-contenteditable-action" 
        @click="toggle"
        v-if="!editMode && actionShow"
      ></i>
    </div>
  </div>
</template>

<script>
import FTSContenteditable from "../../elements/FTSContenteditable";

export default {
  props: {
    value: String,
    placeholder: String
  },
  model: {
    prop: "value",
    event: "updateValue",
  },
  components: {
    "fts-contenteditable": FTSContenteditable,
  },
  data: () => ({
    editMode: false,
    actionShow: false,
  }),
  methods: {
    toggle() {
      this.editMode = true;
      this.$nextTick(() => {
        this.$refs.ftsContenteditable.$el.focus();
      });
    },
    onMouseover() {
      this.actionShow = true;
    },
    onMouseleave() {
      this.actionShow = false;
    },
    onFocus() {
      this.$emit('focus');
    },
    onInput(event) {
      this.$emit('input', event);
    },
    onBlur() {
      this.editMode = false;
      this.$emit('blur');
    },
  },
  computed: {
    content: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('updateValue', val);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fts-automation-contenteditable {
  min-width: 0;
  width: 100%;
  .automation-contenteditable {
    display: flex;
    align-items: center;
  }
  .automation-contenteditable-control {
    width: auto;
  }
  .automation-contenteditable-action {
    margin-left: .375rem;
    color: var(--fts-form-control-placeholder);
    cursor: pointer;
  }
}
</style>